<template>
  <v-dialog :value="value" @input="$emit('input', $event)" persistent max-width="1200"
    :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="dialog-card">
      <v-toolbar class="dialog-toolbar" dark>
        <v-icon class="mr-2">business</v-icon>
        <v-toolbar-title class="dialog-title">{{ $t('Supplier') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-select 
        v-model="seciliTedarikci" 
        :items="PROVIDER_LIST" 
        item-text="urunAdi" 
        return-object 
        label="Tedarikçi Seçin" 
        outlined
        dense 
        class="mt-4 mx-4"
      >
        <template v-slot:selection="{ item }">
          <span class="mr-2">{{ item.urunAdi }}</span>
          <v-chip
            :color="isProviderActive(item) ? 'success' : 'error'"
            text-color="white"
            x-small
            class="font-weight-bold"
          >
            {{ isProviderActive(item) ? 'Aktif' : 'Pasif' }}
          </v-chip>
        </template>

        <template v-slot:item="{ item }">
          <v-layout align-center justify-space-between style="width: 100%;">
            <span>{{ item.urunAdi }}</span>
            <v-chip
              :color="isProviderActive(item) ? 'success' : 'error'"
              text-color="white"
              x-small
              class="font-weight-bold"
            >
              {{ isProviderActive(item) ? 'Aktif' : 'Pasif' }}
            </v-chip>
          </v-layout>
        </template>
      </v-select>

      <v-divider />
      <v-card-text class="pa-4">
        <v-layout row wrap v-if="seciliTedarikci !== null">
          <v-flex xs12 v-if="seciliTedarikci.id === 9">
            <THYNDCProvider :providerData="getExistingProviderData('THYNDC')" @save="addOrEditProvider" />
          </v-flex>
          <v-flex xs12 v-else-if="seciliTedarikci.id === 1">
            <PegasusProvider :providerData="getExistingProviderData('Pegasus')" @save="addOrEditProvider" />
          </v-flex>
          <v-flex xs12 v-else-if="seciliTedarikci.id === 7">
            <AJetProvider :providerData="getExistingProviderData('Ajet')" @save="addOrEditProvider" />
          </v-flex>
          <v-flex xs12 v-else-if="seciliTedarikci.id === 8"> 
            <TurnaProvider :providerData="getExistingProviderData('Turna')" @save="addOrEditProvider" :airlineList="airlineList" />
          </v-flex>
          <v-flex xs12 v-else>
            <GenericProviderInput :providerData="getExistingProviderData(seciliTedarikci.urunAdi)"
              :airlineList="airlineList" @save="addOrEditProvider" />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-3">
        <v-spacer />
        <v-btn outline color="grey darken-1" @click="$emit('input', false)" class="action-btn">
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VFlex } from 'vuetify/lib';
import flightSearchService from './flightSearchService';
import THYNDCProvider from '../comp/ucak/comp/ProviderInputs/THYNDCProvider.vue';
import PegasusProvider from '../comp/ucak/comp/ProviderInputs/PegasusProvider.vue';
import AJetProvider from '../comp/ucak/comp/ProviderInputs/AJetProvider.vue';
import TurnaProvider from '../comp/ucak/comp/ProviderInputs/TurnaProvider.vue';
import GenericProviderInput from '../comp/ucak/comp/ProviderInputs/GenericProviderInput.vue';

const PROVIDER_LIST = [
  { urunAdi: 'TurkishAirlines', id: 0 },
  { urunAdi: 'Pegasus', id: 1 },
  //{ urunAdi: 'OnurAir', id: 2 },
  //{ urunAdi: 'SunExpress', id: 3 },
  //{ urunAdi: 'BiletBank', id: 4 },
  //{ urunAdi: 'Amadeus', id: 5 },
  //{ urunAdi: 'AerTicket', id: 6 },
  { urunAdi: 'Ajet', id: 7 },
  { urunAdi: 'Turna', id: 8 },
  { urunAdi: 'THYNDC', id: 9 }
];

if (process.env.VUE_APP_TARGET === 'couk') {
  PROVIDER_LIST.push({ urunAdi: 'Paximum', id: 16 });
}

export default {
  name: 'ProviderAddDialog',
  props: {
    value: Boolean,
    sessionHeader: { type: Object, required: true },
    providers: { type: Array, default: () => [] },
    airlineList: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      seciliTedarikci: null,
      form: { username: '', password: '', url: '', securityKey: '', acenteKodu: null },
      PROVIDER_LIST,
      tableHeaders: [
        { text: '' },
        { text: 'Provider' },
        { text: 'Kullanıcı' },
        { text: 'Şifre' },
        { text: 'Güvenlik Anahtarı' },
        { text: 'URL' },
        { text: 'Düzenle' }
      ]
    };
  },
  computed: {
    showAcente() {
      return this.seciliTedarikci && this.seciliTedarikci.id === 8;
    }
  },
  components: {
    THYNDCProvider,
    PegasusProvider,
    AJetProvider,
    TurnaProvider,
    GenericProviderInput
  },
  watch: {
    seciliTedarikci(val) {
      this.form.url = (val && val.id === 8) ? 'https://api.turna.com/v1' : '';
    }
  },
  methods: {
    // Tedarikçinin providers listesinde kayıtlı (aktif) olup olmadığını denetler
    isProviderActive(item) {
      if (!this.providers || this.providers.length === 0) return false;
      return this.providers.some(p => p.Provider && p.Provider.toLowerCase() === item.urunAdi.toLowerCase());
    },

    // Alt bileşenlere gönderilecek mevcut provider datasını güvenli şekilde bulur
    getExistingProviderData(providerName) {
      if (!this.providers) return undefined;
      return this.providers.find(p => p.Provider && p.Provider.toLowerCase() === providerName.toLowerCase());
    },

    getImgUrl(provider) {
      const map = {
        TurkishAirlines: require('@/assets/images/TK.png'),
        Turna: require('@/assets/images/turnacom.png'),
        Pegasus: require('@/assets/images/pegasus.png'),
        Ajet: require('@/assets/images/ajet.png'),
        Amadeus: require('@/assets/images/Amadeus_Logo.png')
      };
      return map[provider] || null;
    },

    async ekle() {
      if (!this.seciliTedarikci) {
        this.$emit('notify', { type: 'error', message: 'Lütfen bir tedarikçi seçin' });
        return;
      }
      if (this.showAcente && !this.$refs.acenteAuto.validate()) return;

      const params = {
        SessionHeader: this.sessionHeader,
        Provider: this.seciliTedarikci.urunAdi,
        ProviderType: 'Air',
        ServiceUsername: this.form.username,
        ServicePassword: this.form.password,
        ServiceSecurityKey: this.form.securityKey,
        Address: this.form.url,
        IsTest: false,
        IsActive: true,
        OfficeId: this.form.acenteKodu
      };

      this.loading = true;
      try {
        const resp = await flightSearchService.addCredential(this.$http, params);
        if (resp.body && resp.body.HasError === false) {
          this.$emit('notify', { type: 'success', message: 'Tedarikçi başarıyla eklendi' });
          this.$emit('added');
          this.resetForm();
        } else {
          const msg = (resp.body && resp.body.ErrorMessage) || 'Bir hata oluştu';
          this.$emit('notify', { type: 'error', message: msg });
        }
      } catch {
        this.$emit('notify', { type: 'error', message: 'Tedarikçi eklenemedi' });
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.seciliTedarikci = null;
      this.form = { username: '', password: '', url: '', securityKey: '', acenteKodu: null };
    },

    async addOrEditProvider(provider, type) {
      this.loading = true;
      
      // Gelen provider verisini parametrelere bind ediyoruz
      const params = {
        SessionHeader: this.sessionHeader,
        Provider: provider.Provider || (this.seciliTedarikci ? this.seciliTedarikci.urunAdi : ''),
        ProviderType: 'Air',
        ServiceUsername: provider.ServiceUsername || '',
        ServicePassword: provider.ServicePassword || '',
        ServiceSecurityKey: provider.ServiceSecurityKey || '',
        Address: provider.Address || '',
        IsTest: false,
        IsActive: true,
        OfficeId: provider.OfficeId || null
      };

      try {
        if (type === 'edit') {
          const resp = await flightSearchService.editCredential(this.$http, params);
          if (resp.body && resp.body.HasError === false) {
            this.$emit('notify', { type: 'success', message: 'Tedarikçi başarıyla güncellendi' });
            this.$emit('added');
            this.resetForm();
          } else {
            const msg = (resp.body && resp.body.ErrorMessage) || 'Bir hata oluştu';
            this.$emit('notify', { type: 'error', message: msg });
          }
        } else {
          const resp = await flightSearchService.addCredential(this.$http, params);
          if (resp.body && resp.body.HasError === false) {
            this.$emit('notify', { type: 'success', message: 'Tedarikçi başarıyla eklendi' });
            this.$emit('added');
            this.resetForm();
          } else {
            const msg = (resp.body && resp.body.ErrorMessage) || 'Bir hata oluştu';
            this.$emit('notify', { type: 'error', message: msg });
          }
        }
      } catch {
        this.$emit('notify', { type: 'error', message: 'İşlem sırasında bir hata oluştu' });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.dialog-card {
  border-radius: 12px;
  overflow: hidden;
}

.dialog-toolbar {
  background: linear-gradient(135deg, #1976D2, #1565C0) !important;
}

.dialog-title {
  font-size: 18px;
  font-weight: 500;
}

.action-btn {
  text-transform: none !important;
  border-radius: 8px !important;
}

.action-btn-sm {
  text-transform: none !important;
  border-radius: 6px !important;
}

.logo-cell {
  width: 100px;
  padding: 6px 8px !important;
}

.logo-wrapper {
  width: 80px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 4px;
  overflow: hidden;
}

.providers-table>>>tbody tr:hover td {
  background: #f5f5f5;
}

.provider-mobile-card {
  border-radius: 10px !important;
}
</style>